import React from 'react';

// Keeps a lazy section's anchor (#id) and approximate height in the page while
// its code loads, so in-page links and the scrollbar don't jump.
function SectionPlaceholder({ id }) {
    return <section id={id} className='section' style={{ minHeight: '70vh' }} aria-busy='true' />;
}

export default SectionPlaceholder;
